import { string as yupString } from 'yup';

import { CustomReportParamTypes } from '../../../shared/customReports/constants';

import SelectFormik from '../../../shared/forms/select/selectFormik.component';
import InputFormik from '../../../shared/forms/input/inputFormik.component';
import TextAreaFormik from '../../../shared/forms/textarea/textareaFormik.component';

import { hideField } from '../../../shared/forms/constants';
import { required } from '../../../shared/forms/validators';

import TestQueryButton from './testQueryButton.component';

const isNotQuery = ({ formik }) => formik.values.type !== CustomReportParamTypes.query;
const isValidatorType = ({ formik }) => formik.values.type === CustomReportParamTypes.validator;

const hideIfNotQueryCondition = {
  when: isNotQuery,
  then: hideField,
  otherwise: {
    additionalProps: { required: true },
  },
};

const hideIfValidatorCondition = {
  when: isValidatorType,
  then: hideField,
};

export const requireWhenQueryOrValidator = (label, validator) =>
  validator.when('type', {
    is: type => type === CustomReportParamTypes.query || type === CustomReportParamTypes.validator,
    then: validator.required().nullable(),
    otherwise: validator.nullable(),
  });

export const requireWhenQueryType = (label, validator) =>
  validator.when('type', {
    is: type => type === CustomReportParamTypes.query,
    then: validator.required().nullable(),
    otherwise: validator.nullable(),
  });


const schema = [
  {
    name: 'type',
    component: SelectFormik,
    meta: { label: 'Param Type', optionsKey: 'paramTypesOptions' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'mappingName',
    component: InputFormik,
    meta: { label: 'Mapping Name' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'query',
    component: TextAreaFormik,
    meta: { label: 'Query' },
    options: { yupType: yupString(), validationRules: [requireWhenQueryOrValidator] },
    additionalProps: { resize: 'vertical' },
    conditions: [{
      when: ({ formik }) => formik.values.type !== CustomReportParamTypes.query
        && formik.values.type !== CustomReportParamTypes.validator,
      then: hideField,
      otherwise: {
        additionalProps: { required: true },
      },
    }],
  },
  {
    name: 'testQuery',
    component: TestQueryButton,
    meta: { valueGetter: ({ formik }) => formik.values.query },
    options: { readOnly: true },
    conditions: [{
      when: isNotQuery,
      then: hideField,
    }, hideIfValidatorCondition],
  },
  {
    name: 'value',
    component: SelectFormik,
    meta: { label: 'Dropdown Value', optionsKey: 'reportParamToEditOptions' },
    options: { yupType: yupString(), validationRules: [requireWhenQueryType] },
    conditions: [hideIfNotQueryCondition, hideIfValidatorCondition],
  },
  {
    name: 'label',
    component: SelectFormik,
    meta: { label: 'Dropdown Label', optionsKey: 'reportParamToEditOptions' },
    options: { yupType: yupString(), validationRules: [requireWhenQueryType] },
    conditions: [hideIfNotQueryCondition, hideIfValidatorCondition],
  },
];

export default schema;
